export default {"src":"/_next/static/image/public/images/Bundle_deal_pdp_updated.02705893f77e32f79867d5a7c092602e.svg","height":24,"width":99};